var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "import-se-dialog",
      attrs: {
        title: _vm.role == 1 ? "Batch Operate" : "Batch Add",
        width: "auto",
        visible: _vm.dialogVisible,
        scrollbar: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _vm.role != 1
            ? _c("el-tab-pane", {
                attrs: { label: "Batch Add", name: "seAddList" },
              })
            : _vm._e(),
          _vm.role == 1
            ? _c("el-tab-pane", {
                attrs: {
                  label: "Batch Transfer/Delete",
                  name: "seTransOrDelList",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "export",
          attrs: { type: "primary", icon: "iconfont icon-export" },
          on: { click: _vm.exportButton },
        },
        [_vm._v(" Export ")]
      ),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              staticClass: "batch-add-table",
              attrs: { data: _vm.tableData, height: _vm.height },
            },
            [
              _c("el-table-column", {
                attrs: { label: "No", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ $index }) {
                      return [_c("div", [_vm._v(_vm._s($index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "seName", label: "Name", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "province", label: "Province", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "city", label: "City", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hospital",
                  label: "Hospital/Institution",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "department",
                  label: "Department",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "hcpId", label: "HCPID", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "hcpType", label: "Type", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "User", prop: "mslName", width: "110" },
              }),
              _vm.tab === "seAddList"
                ? _c("el-table-column", {
                    attrs: { prop: "eaStatus", label: "Source", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.eaStatus
                                ? _c("el-tag", { attrs: { type: "success" } }, [
                                    _vm._v(" eAuthorship"),
                                  ])
                                : _c("el-tag", { attrs: { type: "warning" } }, [
                                    _vm._v("CMDS"),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1996062380
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "statusName", label: "Status", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: { type: row.status ? "success" : "warning" },
                          },
                          [_vm._v(" " + _vm._s(row.statusName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.submit },
            },
            [_vm._v(" Submit")]
          ),
          _c("el-button", { on: { click: _vm.onClosed } }, [
            _vm._v(" Cancel "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }